/**
 * Simple LRU (Least Recently Used) Cache implementation
 * Evicts least recently used items when capacity is reached
 */
export class LruCache {
    maxSize;
    cache;
    /**
     * Create a new LRU cache
     * @param maxSize - Maximum number of entries (default: 1000)
     */
    constructor(maxSize = 1000) {
        if (maxSize <= 0) {
            throw new Error('LRU cache maxSize must be greater than 0');
        }
        this.maxSize = maxSize;
        this.cache = new Map();
    }
    /**
     * Get a value from the cache
     * Marks the key as recently used
     */
    get(key) {
        const value = this.cache.get(key);
        if (value !== undefined) {
            // Move to end (most recently used)
            this.cache.delete(key);
            this.cache.set(key, value);
        }
        return value;
    }
    /**
     * Set a value in the cache
     * Evicts least recently used item if at capacity
     */
    set(key, value) {
        // If key exists, delete it first to update position
        if (this.cache.has(key)) {
            this.cache.delete(key);
        }
        else if (this.cache.size >= this.maxSize) {
            // Evict least recently used (first item)
            const firstKey = this.cache.keys().next().value;
            if (firstKey !== undefined) {
                this.cache.delete(firstKey);
            }
        }
        this.cache.set(key, value);
    }
    /**
     * Clear all entries from the cache
     */
    clear() {
        this.cache.clear();
    }
    /**
     * Get current cache size
     */
    get size() {
        return this.cache.size;
    }
}
//# sourceMappingURL=lru-cache.js.map